// Fix for ResizeObserver loop limit exceeded error
// This error is benign and doesn't affect functionality.
// Imported as a side-effect in index.js BEFORE react-dom so it registers
// its capture-phase listener before CRA's error overlay does.

// 1. Suppress via capture-phase listener (must run before CRA's overlay).
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true /* capture — fires before CRA's overlay handler */);

// 2. Suppress via window.onerror (catches anything the event listener misses).
const originalOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (message && typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true; // suppress
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

// 3. Patch ResizeObserver to defer callbacks via requestAnimationFrame,
//    which avoids the "loop completed with undelivered notifications"
//    condition in the first place.
const OriginalResizeObserver = window.ResizeObserver;
if (OriginalResizeObserver) {
  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}
